function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M43.994,12.735a7.468,7.468,0,0,0-2.729-2.729,7.548,7.548,0,0,0-7.529,0,7.467,7.467,0,0,0-2.73,2.729,7.548,7.548,0,0,0,0,7.529,7.468,7.468,0,0,0,2.73,2.729,7.548,7.548,0,0,0,7.529,0,7.467,7.467,0,0,0,2.729-2.729,7.549,7.549,0,0,0,0-7.529Zm-2.119,4.39a.634.634,0,0,1-.625.625h-2.5v2.5a.634.634,0,0,1-.625.625h-1.25a.634.634,0,0,1-.625-.625v-2.5h-2.5a.634.634,0,0,1-.625-.625v-1.25a.634.634,0,0,1,.625-.625h2.5v-2.5a.634.634,0,0,1,.625-.625h1.25a.634.634,0,0,1,.625.625v2.5h2.5a.634.634,0,0,1,.625.625Z",
  transform: "translate(-30 -9)"
});

var SvgAddCircleBlue = function SvgAddCircleBlue(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "#118AF9",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAddCircleBlue, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/add-circle-blue.0554377c.svg";
export { ForwardRef as ReactComponent };